// src/router.ts — Hash-based SPA Router (Section 2.3)

export type RouteHandler = (params?: Record<string, string>) => HTMLElement | string;

export interface RouteDefinition {
  path: string; // e.g. '#/', '#/read', '#/sprint'
  title: string;
  render: RouteHandler;
}

export class Router {
  private routes: Map<string, RouteDefinition> = new Map();
  private currentPath = '';
  private onNavigateCallbacks: Array<(path: string) => void> = [];

  constructor() {
    window.addEventListener('hashchange', () => this.handleHashChange());
  }

  register(path: string, title: string, render: RouteHandler): this {
    this.routes.set(path, { path, title, render });
    return this;
  }

  onNavigate(callback: (path: string) => void): () => void {
    this.onNavigateCallbacks.push(callback);
    return () => {
      this.onNavigateCallbacks = this.onNavigateCallbacks.filter((cb) => cb !== callback);
    };
  }

  navigate(path: string): void {
    if (window.location.hash === path) {
      this.handleHashChange();
    } else {
      window.location.hash = path;
    }
  }

  getCurrentPath(): string {
    return this.currentPath;
  }

  resolve(): { title: string; content: HTMLElement | string } {
    let hash = window.location.hash || '#/';
    if (!hash.startsWith('#/')) {
      hash = '#/';
    }

    // Match exact or prefix
    const route = this.routes.get(hash) || this.routes.get('#/');
    this.currentPath = hash;

    if (!route) {
      return {
        title: 'Clawey 11+',
        content: '<div class="morris-card"><h2>Station Under Discovery</h2><p>Returning to harbour...</p></div>',
      };
    }

    return {
      title: route.title,
      content: route.render(),
    };
  }

  private handleHashChange(): void {
    const hash = window.location.hash || '#/';
    this.currentPath = hash;
    this.onNavigateCallbacks.forEach((cb) => cb(hash));
  }
}

export const globalRouter = new Router();
